import { ReactNode } from "react";

export type RepeaterProps<T> = {
  items: T[];
  render: (item: T, index: number) => ReactNode;
  filter?: (item: T) => boolean;
  sort?: (a: T, b: T) => number;
  fallback?: ReactNode | ((error: Error, item: T) => ReactNode);
};

const Repeater = <T,>({ items, render, filter, sort, fallback }: RepeaterProps<T>) => {
  let processedItems = [...items];

  if (filter) {
    processedItems = processedItems.filter(filter);
  }

  if (sort) {
    processedItems.sort(sort);
  }

  const handleError = (error: Error, item: T) => {
    if (fallback) {
      if (typeof fallback === "function") {
        return fallback(error, item);
      }
      return fallback;
    }
    throw error;
  };

  return (
    <>
      {processedItems.map((item, index) => {
        try {
          return render(item, index);
        } catch (error) {
          if (error instanceof Error) {
            return handleError(error, item);
          }
          return handleError(new Error(String(error)), item);
        }
      })}
    </>
  );
};

export { Repeater };
